import {getPlayersJsonSuccess, getPlayersSuggestedJsonSuccess} from "modules/actions/players";
import {PoolTabsType} from "modules/enums";
import {createReducer} from "redux-act";

type TPlayersStore = ReturnType<typeof getPlayersJsonSuccess>["payload"] &
	ReturnType<typeof getPlayersSuggestedJsonSuccess>["payload"];

const defaultState: TPlayersStore = {
	players: {},
	poolPlayers: {
		[PoolTabsType.Favorite]: [],
		[PoolTabsType.Club]: [],
		[PoolTabsType.Suggested]: [],
		[PoolTabsType.Popular]: [],
	},
	suggestedPlayers: [],
};

export const players = createReducer({}, defaultState);

players.on(getPlayersJsonSuccess, (state, payload) => ({
	...state,
	...payload,
}));

players.on(getPlayersSuggestedJsonSuccess, (state, payload) => ({
	...state,
	...payload,
}));
